'use client';

import { FlexContainer } from './FlexContainer';
import { LazyLoad } from './LazyLoad';
import { LoadingIndicator } from './LoadingIndicator';
import { DEFAULT_TIME_SERIES_CHART_HEIGHT } from './timeSeriesLineChart.constants';

import type { TimeSeriesLineChartProps } from './TimeSeriesLineChart';

export type TimeSeriesLineChartLazyProps = TimeSeriesLineChartProps;

const loadTimeSeriesLineChart = () => import('./TimeSeriesLineChart');

export function TimeSeriesLineChartLazy(props: TimeSeriesLineChartLazyProps) {
  const effectiveHeight = props.height ?? DEFAULT_TIME_SERIES_CHART_HEIGHT;

  return (
    <LazyLoad
      componentProps={props}
      fallback={
        <FlexContainer
          className="w-full"
          data-testid="time-series-line-chart-loading"
          items="center"
          justify="center"
          style={{ height: `${effectiveHeight}px` }}
        >
          <LoadingIndicator />
        </FlexContainer>
      }
      loader={loadTimeSeriesLineChart}
    />
  );
}
